import React from 'react';
import { IfmsRoute }from '../../../config/types';

const IfmsHelp = React.lazy(() => import('../ifmsHelp/IfmsHelp'));

const routes:Array<IfmsRoute> = [
  {path: '/utilities', component: IfmsHelp},
];

export default routes;